import React, { useCallback, useMemo } from "react";
import { Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useQuery } from "react-query";
import { fetchGetCrmTopics } from "../queries/crmTopics";
import JsonApiDataSelect from "./JsonApiDataSelect";

export const CrmTopicSelect = (jsonApiSelectProps: any) => {
  const dispatch = useDispatch();
  const crmTopicsQuery = useQuery(["crmTopics"], fetchGetCrmTopics(dispatch));
  const crmTopicOptions = useCallback((item: any) => {
    return {
      key: item.id,
      value: item.id,
      text: item.attributes.name,
    };
  }, []);
  const clearOption = useMemo(
    () => ({
      key: "",
      value: "0",
      text: "None",
    }),
    [],
  );

  return (
    <JsonApiDataSelect
      placeholder='Topic'
      {...jsonApiSelectProps}
      query={crmTopicsQuery}
      toOptions={crmTopicOptions}
      clearOption={clearOption}
    />
  );
};

export const ControlledCrmTopicSelect = ({ name, control, ...crmTopicSelectProps }: any) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ onChange, value }) => (
        <CrmTopicSelect
          {...crmTopicSelectProps}
          name={name}
          onChange={(e: any, { value }: any) => onChange(value)}
          value={value}
        />
      )}
    />
  );
};

export default CrmTopicSelect;
